<template>
  <div class="game-buddy-apply-container">
    <el-card class="apply-card" shadow="hover">
      <div slot="header" class="clearfix">
        <span>成为陪玩选手</span>
      </div>
      <el-form :model="applyForm" :rules="rules" ref="applyForm" label-width="100px">
        <el-form-item label="游戏专长" prop="expertise">
          <el-input v-model="applyForm.expertise" placeholder="请输入您擅长的游戏，多个游戏用逗号分隔"></el-input>
        </el-form-item>
        <el-form-item label="自我介绍" prop="introduction">
          <el-input
            v-model="applyForm.introduction"
            type="textarea"
            :rows="5"
            placeholder="请介绍一下自己，让更多玩家了解您"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitApply" :loading="loading">提交申请</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>

export default {
  name: 'GameBuddyApply',
  data() {
    return {
      loading: false,
      applyForm: {
        expertise: '',
        introduction: ''
      },
      rules: {
        expertise: [
          { required: true, message: '请输入游戏专长', trigger: 'blur' },
          { min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur' }
        ],
        introduction: [
          { required: true, message: '请输入自我介绍', trigger: 'blur' },
          { min: 10, max: 500, message: '长度在 10 到 500 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitApply() {
      this.$refs.applyForm.validate((valid) => {
        if (valid) {
          this.loading = true
          // 从 localStorage 获取当前用户 ID
          const user = JSON.parse(localStorage.getItem('user'))
          if (user) {
            this.applyForm.userId = user.id
            this.$axios.post('/game-buddy/apply', this.applyForm)
              .then(response => {
                this.$message.success('申请提交成功，请等待管理员审核')
                this.resetForm()
              })
              .catch(error => {
                this.$message.error('申请提交失败，请重试')
                console.error('Apply error:', error)
              })
              .finally(() => {
                this.loading = false
              })
          } else {
            this.$message.error('请先登录')
            this.loading = false
          }
        }
      })
    },
    resetForm() {
      this.$refs.applyForm.resetFields()
    }
  }
}
</script>

<style scoped>
.game-buddy-apply-container {
  padding: 20px 0;
}

.apply-card {
  margin-bottom: 20px;
}
</style>
